/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgFramework } from '../../models/esg-framework';

export interface YearsByProfileByFramework$Params {
  profileId: number;
  framework: EsgFramework;
}

export function yearsByProfileByFramework(http: HttpClient, rootUrl: string, params: YearsByProfileByFramework$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
  const rb = new RequestBuilder(rootUrl, yearsByProfileByFramework.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('framework', params.framework, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<number>>;
    })
  );
}

yearsByProfileByFramework.PATH = '/esg/profile/{profileId}/esg/framework/{framework}/years';
